import { render, staticRenderFns } from "./userInfofollowList.vue?vue&type=template&id=3d782a4e&scoped=true&"
import script from "./userInfofollowList.vue?vue&type=script&lang=js&"
export * from "./userInfofollowList.vue?vue&type=script&lang=js&"
import style0 from "./userInfofollowList.vue?vue&type=style&index=0&id=3d782a4e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d782a4e",
  null
  
)

export default component.exports